import { render } from "./AddGuestQty.vue?vue&type=template&id=128d8677"
import script from "./AddGuestQty.vue?vue&type=script&lang=js"
export * from "./AddGuestQty.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__